import React from "react";
import HomeSeo from "./HomeSeo";
import { NavLink } from "react-router-dom";

function NotFound() {
  return (
    <div>
      <>
        <HomeSeo />
        <div className="site-main">
          <section className="prt-row error-404">
            <div className="container-fluid mb-5">
              <div className="row align-items-center">
                <div className="col-lg-12 col-md-12">
                  <div className="page-content-main text-center">
                    <div className="page-content">
                      <h2>
                        <i className="fa fa-thumbs-o-down" />
                      </h2>
                      <h3>404 Error</h3>
                      <p>
                        Oops! The page you're looking for can't be found. It
                        might have been removed or the link could be broken.
                      </p>
                    </div>
                    <div className="">
                      <NavLink
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                        to="/"
                      >
                        Back to home
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    </div>
  );
}

export default NotFound;
